export const SUPPORT_FIRSTNAME_TOKEN = '{{firstname}}';

export function applySupportTemplateMessage(template: string, firstName?: string | null): string {
  const name = (firstName ?? '').trim() || 'there';
  return template.replaceAll(SUPPORT_FIRSTNAME_TOKEN, name);
}

export function supportTemplatePreviewWithSampleName(template: string): string {
  return applySupportTemplateMessage(template, 'Harry');
}

export function insertSupportTemplateToken(
  body: string,
  token: string,
  selectionStart: number | null,
  selectionEnd: number | null,
): { body: string; cursor: number } {
  const start = selectionStart ?? body.length;
  const end = selectionEnd ?? start;
  const nextBody = `${body.slice(0, start)}${token}${body.slice(end)}`;
  return {
    body: nextBody,
    cursor: start + token.length,
  };
}

export function createSupportTemplateMessage(
  partial?: { label?: string; body?: string },
): { id: string; label: string; body: string } {
  return {
    id: crypto.randomUUID(),
    label: partial?.label?.trim() ?? 'New template',
    body: partial?.body?.trim() ?? `Hi ${SUPPORT_FIRSTNAME_TOKEN}, `,
  };
}
